
// const IP='https://dongtai.huayiyun.net:8888/api'
const IP='https://demo-dongtai.huayiyun.net:8082/dongtai-api'
// const IP='http://192.168.2.83:8080'
// const IP='http://127.0.0.1:8080'

//接口
const domain={
    loginDB:IP+'/dongtaiecg/db/login',//登录
    getImageCode:IP+'/dongtaiecg/getImageCode',//获取图形验证码
    getImgCodeState:IP+'/dongtaiecg/getImgCodeState',//验证码是否验证标志
    getLoginCode:IP+'/dongtaiecg/getLoginCode',//获取手机验证码登录

    login:IP+'/dongtaiecg/login',//登录
    logout:IP+'/dongtaiecg/logout',//登录
    getAllHosp:IP+'/dongtaiecg/getAllHosp',//获取登陆者所任职的全部医院
    getHospPerms:IP+'/dongtaiecg/getHospPerms',//获得选择医院的权限
    getUserInfo:IP+'/dongtaiecg/getUserInfo',//获得选择医院后的个人信息

    queryGangedDepartmentList:IP+'/admin/hosp/queryGangedDepartmentList',//获取联动科室
    queryProRankList:IP+'/admin/doctor/queryProRankList',//医生公共职称
    queryRoleList:IP+'/admin/doctor/queryRoleList',//获得角色列表
    getReadAndWriteOSS:IP+'/dongtaiecg/oss/getReadAndWriteOSS',//获得oss临时账号
    getDeviceTypeList:IP+'/dongtaiecg/diagnosis/diag/getDeviceTypeList',//获取设备类型列表
    getCaseStatusList:IP+'/dongtaiecg/diagnosis/diag/getCaseStatusList',//获取病历状态列表

    queryHosp:IP+'/admin/hosp/queryHosp',//查询医院信息
    updateHospInfo:IP+'/admin/hosp/updateHospInfo',//更新医院信息
    addDept:IP+'/admin/hosp/addDept',//添加科室
    queryDeptFromHosp:IP+'/admin/hosp/queryDeptFromHosp',//查询科室列表
    queryDeptBelongHosp:IP+'/admin/hosp/queryDeptBelongHosp',//查询可选择的科室列表
    updateDept:IP+'/admin/hosp/updateDept',//更新科室信息

    queryUserFromHosp:IP+'/admin/doctor/queryUserFromHosp',//根据医院查询医生列表

    judgeDocIsExist:IP+'/admin/doctor/judgeDocIsExist',//根据手机号查询医生信息
    openAccount:IP+'/admin/doctor/openAccount',//添加医生
    updateUserInfo:IP+'/admin/doctor/updateUserInfo',//修改医生信息
    permissionChange:IP+'/admin/doctor/permissionChange',//管理员修改医生权限

    queryHospBalance:IP+'/admin/hosp/queryHospBalance',//查询医院账户余额信息
    updateHospPriceList:IP+'/admin/hosp/updateHospPriceList',//设置医院普价
    queryHospPriceList:IP+'/admin/hosp/queryHospPriceList',//查询医院普价

    listChildHosp:IP+'/admin/hosp/listChildHosp',//查询下级医院列表

    rechargeOrder:IP+'/recharge/add',//医院充值（订单生成）
    // rechargeMode:IP+'/admin/hosp/rechargeMode',//医院充值（修改支付类型）
    rechargeAliQRcode:IP+'/recharge/AliPay',//充值获取支付宝二维码
    rechargeWeQRcode:IP+'/recharge/WeChat',//充值获取微信二维码
    // rechargeOrder:IP+'/admin/hosp/rechargeOrder',//医院充值（订单生成）
    // rechargeMode:IP+'/admin/hosp/rechargeMode',//医院充值（修改支付类型）
    // rechargeAliQRcode:IP+'/admin/hosp/aliQRcode',//充值获取支付宝二维码
    // rechargeWeQRcode:IP+'/admin/hosp/weQRcode',//充值获取微信二维码
    // rechargePayment:IP+'/admin/hosp/rechargePayment',//医院充值（确认付款）
    confirm:IP+'/recharge/confirm',//确认付款

    //申请端
    getApplyCaseInfoList:IP+'/dongtaiecg/apply/getApplyCaseInfoList',//获取申请列表
    getDepartmentListRel:IP+'/admin/hosp/queryDeptBelongHospOther',//获取医院的科室列表
    getPhysicianList:IP+'/dongtaiecg/apply/getPhysicianList',//获取科室的医生列表
    getHospInfoList:IP+'/dongtaiecg/apply/getHospInfoList',//获得关联上级医院列表

    storage:IP+'/case/storage',//表单暂存
    save:IP+'/case/save',//保存病历
    cancel:IP+'/case/cancel',//取消申请
    applyLocal:IP+'/case/applyLocal',//申请本院诊断
    applySalf:IP+'/case/applySalf',//申请高端诊断

    getPayOrder:IP+'/case/getPayOrder',//获取订单信息
    judgePayPassword:IP+'/dongtaiecg/judgePayPassword',//验证登录密码
    payment:IP+'/pay/payment',//余额支付，三方支付确认
    weQRcode:IP+'/pay/weQRcode',//获取微信支付二维码 
    aliQRcode:IP+'/pay/aliQRcode',//获取支付宝二维码
    aliPayNo:IP+'/pay/aliPayNo',//三方支付回传


    getCaseInfoDetailById:IP+'/dongtaiecg/diagnosis/diag/getCaseInfoDetailById',//根据病历id查询病例信息

    //诊断端
    getCaseInfoListByStatus:IP+'/dongtaiecg/diagnosis/diag/getCaseInfoListByStatus',//获得待诊断、诊断中、已完成列表
    updateOccupyCaseById:IP+'/dongtaiecg/diagnosis/diag/updateOccupyCaseById',//诊断，占有病历
    caseGiveUp:IP+'/dongtaiecg/diagnosis/diag/caseGiveUp',//放弃病历
    caseSubmit:IP+'/dongtaiecg/diagnosis/diag/caseSubmit',//提交报告
    caseReject:IP+'/dongtaiecg/diagnosis/diag/caseReject',//驳回

    //主治功能
    getChiefCaseInfoList:IP+'/dongtaiecg/apply/getChiefCaseInfoList',//获取主治医生病历列表

    //个人中心
    modifyPassword:IP+'/dongtaiecg/userinfo/modifyPassword',//密码修改
    modifyPersonalInfomation:IP+'/dongtaiecg/userinfo/modifyPersonalInfomation',//修改个人资料
    getVerificationCode:IP+'/dongtaiecg/getVerificationCode',//获取手机验证码
    getBackPassword:IP+'/dongtaiecg/getBackPassword',//重新设置密码

    listPayRecord:IP+'/pay/listPayRecord',//支付/充值记录列表
    rouse:IP+'/dongtaiecg/rouse', //唤醒接口

    listCase:IP+'/case/list'

}

export default domain





// WEBPACK FOOTER //
// ./src/service/getData.js